import {
  registerTokenStorage,
  getEventTargetInstance
} from '@cimpress-technology/authfront-sdk-core'

import { NavHint } from '../common/types'
import type {
  UserSignInOptions, UserSignOutPayload, SESSION_TYPE, UserTokenContext, UserIdentityEvent, AuthorizationInfo,
  ErrorAndResultCallbackFn, UrlParam
} from '../common/types'

import { EMPTY_IDENTITY } from '../common/constants'

import { getWindow, transformAuthIdentityEventToUserIdentityEvent } from './utils/helper'
import { AuthService } from './auth'
import { AuthenticationError } from './errors'
import { cookieTokenStorage, init, initWithConfig, type Config } from './init'
import { onUserIdentityUpdate } from './utils/events'

// Register cookie-based token storage with the core SDK
registerTokenStorage(cookieTokenStorage)

// Bridge internal userIdentity events to the window object so fragments can
// listen via: window.addEventListener('userIdentity', handler)
const eventTargetInstance = getEventTargetInstance()
eventTargetInstance.addEventListener('userIdentity', (e: any) => {
  const userDetails = e.detail
  const identity = transformAuthIdentityEventToUserIdentityEvent(userDetails)
  getWindow().dispatchEvent(new CustomEvent('userIdentity', { detail: identity }))
  if (identity && identity.isSignedIn) {
    cookieTokenStorage.setPresumedLoginState()
  } else {
    cookieTokenStorage.deletePresumedLoginState()
  }
})
eventTargetInstance.addEventListener('completeCallbackEvent', (e: any) => {
  getWindow().dispatchEvent(new CustomEvent('userIdentity', { detail: EMPTY_IDENTITY }))
})

export {
  init,
  initWithConfig,
  onUserIdentityUpdate,
  AuthenticationError,
  AuthService as WebAuth,
  NavHint,
  type UrlParam,
  type Config,
  type UserSignInOptions,
  type UserSignOutPayload,
  type SESSION_TYPE,
  type UserTokenContext,
  type UserIdentityEvent,
  type AuthorizationInfo,
  type ErrorAndResultCallbackFn,
}

export default {
  initWithConfig,
  init,
  WebAuth: AuthService,
  NavHint,
  onUserIdentityUpdate
}
